import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { useMyBonusHistoryQuery } from '@shared/generated'
import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'

interface ISavingsProps {
  className?: string;
}

export const Savings: React.FC<ISavingsProps> = ({ className }) => {
  const { t: tn } = useTranslation('personal')
  const { data: { bonusHistory } = {} } = useMyBonusHistoryQuery()

  const totalSpent =
    bonusHistory
      ?.filter((item) => item?.type === 'charge')
      .reduce((sum, item) => sum + (item?.amount || 0), 0) || 0

  return (
    <div className={classNames(styles.savings, className)}>
      <span className={styles.savings__text}>{tn('bonus.savings')}</span>
      <div className={styles.savings__wrapper}>
        <span className={styles.savings__count}>
          {formatPrice(totalSpent || 0, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            style: 'decimal',
          })}{' '}
          ₸
        </span>
        <span className={styles.savings__description}>
          {tn('bonus.card-loyalty')}
        </span>
      </div>
    </div>
  )
}
